import { useContext } from "react";
import DataContext from "../../context/data-context";
import SidebarButton from "../UI/SidebarButton";
import { FaUserCircle } from "react-icons/fa";
import { UtilityContext } from "../../context/util-context";
import { useLocation } from "react-router-dom";
import Joyride from "react-joyride";

export default function Sidebar() {
  const location = useLocation();
  const { navigate } = useContext(UtilityContext);
  const { partner } = useContext(DataContext);

  // Get page address from url
  const selected = location.pathname.slice(1).split("/")[0];

  const selectHandler = (item, e) => {
    navigate(`/${item.toLowerCase()}`, e);
  };

  return (
    <div className="hidden w-full px-6 py-12 bg-stone-900 rounded-xl md:block">
      <div
        data-tour="profile"
        className="flex flex-col items-center space-y-2 cursor-pointer hover:opacity-80"
        onClick={(e) => navigate("/settings/profile", e)}
      >
        <div className="w-16 h-16">
          {partner.photo ? (
            <img
              src={partner.photo}
              className="w-16 h-16 rounded-full contain"
            />
          ) : (
            <FaUserCircle className="w-full h-full text-yellow-600" />
          )}
        </div>
        <p className="text-center text-stone-300">
          {partner?.type === "business" ? partner?.businessName : partner?.name}
        </p>
      </div>
      <div className="grid gap-8 mt-16 mb-12" data-tour="menu">
        <SidebarButton
          title="General"
          selected={selected}
          onClick={() => selectHandler("General")}
        />
        <SidebarButton
          title="Vehicles"
          selected={selected}
          onClick={() => selectHandler("Vehicles")}
        />
        <SidebarButton
          title="Payments"
          selected={selected}
          onClick={() => selectHandler("Payments")}
        />
        <SidebarButton
          title="Settings"
          selected={selected}
          onClick={() => selectHandler("Settings")}
        />
      </div>
    </div>
  );
}
